<script>
</script>

<div class="legal-container">
    <p class="text-fs-15 text-center m-b-10">
        <strong>
            Algunos paquetes tienen disponible la opción de autoinstalación</strong
        >
    </p>
    <p class="text-fs-15 text-center m-b-10">
        <strong>
            Los paquetes mostrados están sujetos a la disponibilidad según tu
            localidad.</strong
        >
    </p>
    <p class="text-fs-15 text-center m-b-20">
        Sujeto a nuestros
        <a
            href="https://www.izzi.mx/legales/terminos-condiciones-izzi"
            class="base-text underline fw-semibold"
            target="_blank">Terminos y condiciones.</a
        >
        <a
            href="https://www.izzi.mx/medidor-velocidad"
            class="base-text underline fw-semibold"
            target="_blank">Consulta aquí</a
        >
        las velocidades promedio de descarga en hora pico.
        <a
            href="https://www.izzi.mx/legales/terminos-condiciones-izzi"
            class="base-text underline fw-semibold"
            target="_blank">Llamadas ilimitadas</a
        >
        a los destinos incluidos en la oferta.
    </p>
</div>
